module.exports = __webpack_public_path__ + "static/media/value-prop-icon-2.b52031ce.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/value-prop-icon-2.svg
// module id = 1411
// module chunks = 0